module.exports = __webpack_public_path__ + "static/media/funitures4.0a8a5f26.svg";